<script setup lang="ts">
  import OnboardingSlide from './OnboardingSlide.vue'
  import OnboardingSlideHeadline from './OnboardingSlideHeadline.vue'
  import OnboardingSlideSplitContent from './OnboardingSlideSplitContent.vue'
  import OnboardingSlideLottieAnimation from './OnboardingSlideLottieAnimation.vue'

  interface Props {
    headline: string
    text: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    animationData: any
    loop?: boolean
    mode?: 'center' | 'opposite'
    slideIndex?: number
  }

  const props = withDefaults(defineProps<Props>(), {
    loop: true,
    mode: 'opposite',
    slideIndex: undefined,
  })
</script>
<template>
  <onboarding-slide :slide-index="props.slideIndex">
    <onboarding-slide-headline>{{ props.headline }}</onboarding-slide-headline>
    <onboarding-slide-split-content
      :top-ratio="55"
      :bottom-ratio="30"
      gap="15%"
      :mode="props.mode"
      class="max-width-container"
    >
      <template #top>
        <onboarding-slide-lottie-animation
          :animation-data="props.animationData"
          :loop="props.loop"
        ></onboarding-slide-lottie-animation>
      </template>
      <template #bottom>
        <p class="text-center">
          {{ props.text }}
        </p>
      </template>
    </onboarding-slide-split-content>
  </onboarding-slide>
</template>
<style scoped>
  .max-width-container {
    max-width: 400px;
    margin: 0 auto;
  }
</style>
